/**
 * 阿里云 OSS 图片缩略图 URL（列表/卡片预览用，大幅减小下载体积）
 * @param {string} url 原图地址
 * @param {number} width 目标宽度（px）
 * @param {number} quality 质量 1-100
 */
export function ossThumb(url, width = 200, quality = 80) {
  if (!url || typeof url !== 'string') {
    return url
  }
  const trimmed = url.trim()
  if (!trimmed) {
    return url
  }
  if (!/aliyuncs\.com/i.test(trimmed)) {
    return url
  }
  // 带签名的临时 URL 不能追加处理参数
  if (/[?&]Signature=/i.test(trimmed) || /[?&]Expires=/i.test(trimmed)) {
    return url
  }
  const sep = trimmed.includes('?') ? '&' : '?'
  return `${trimmed}${sep}x-oss-process=image/resize,w_${width}/quality,q_${quality}`
}

/**
 * 为 Upload 文件项补充 thumbUrl
 */
export function withOssThumb(fileItem, width = 200) {
  if (!fileItem) {
    return fileItem
  }
  const url = fileItem.url || fileItem.path
  if (!url) {
    return fileItem
  }
  return {
    ...fileItem,
    thumbUrl: ossThumb(url, width)
  }
}
